import {useEffect} from 'react';
import './Style/App.scss';
import Body from './Body/Body';
import Footer from './Footer/Footer';
import Overlay from './Overlay/Overlay';
import gsap from 'gsap';

function App() {
  useEffect(() => {

    gsap.to('body', 0, {css: {visibility: 'visible'}});

    const tl = gsap.timeline();
    tl.from('.subHeading', 1.8, {
      y: 100,
      ease: "power4.out",
      delay: 1,
      skewY: 7,
      stagger: {
        amount: 0.3
      }
    }).to('.overlay-top', 1.6, {
      height: 0,
      ease: 'expo.inOut',
      stagger: 0.4
    }).to('.overlay-bottom', 1.6, {
      width: 0,
      ease: 'expo.inOut',
      delay: -.8,
      stagger: {
        amount: .4,
      }
    }).to('.intro-overlay', 0, {css: {display: 'none'}})
  },[])
  return (
    <div className = "App">
      <Overlay></Overlay>
      <Body></Body>
      <Footer></Footer>
    </div>
  );
}

export default App;
